<!-- 最左边的选择框 -->
<template>
  <div class="mycard">
    <header>
      <img src="static/images/bot.png" class="avatar">
    </header>
    <div class="navbar" @click="clearSearch">
      <router-link to="/chat" class="icon iconfont icon-msg"></router-link>
      <!-- <router-link to="/friend" class="icon iconfont icon-friend"></router-link>
	         <router-link to="/my" class="icon iconfont icon-collection"></router-link> -->
    </div>
    <footer>
      <!-- <i class="icon iconfont icon-more"></i> -->
      <!-- <router-link to="/my" class="icon iconfont icon-more"></router-link> -->
    </footer>
  </div>
</template>

<script>
import api from '../../api/api'
export default {
  data() {
    return {
      user: {}
    }
  },
  created() {
    this.loadUser()
  },
  methods: {
    getRequestParams() {
      try {
        // 创建一个URL对象
        const urlObj = new URL(window.location.href);

        // 如果是hash路由，需要单独处理hash部分
        const hash = urlObj.hash;
        let params = {};

        if (hash.includes('?')) {
          const hashParams = new URLSearchParams(hash.split('?')[1]);
          params = Object.fromEntries(hashParams.entries());
        } else if (urlObj.search) {
          // 处理普通查询参数
          const searchParams = new URLSearchParams(urlObj.search);
          params = Object.fromEntries(searchParams.entries());
        }

        console.log('App.vue 解析的参数:', params);
        return params;
      } catch (error) {
        console.error('解析URL参数时出错:', error);
        return {};
      }
    },

    loadUser() {
      // api.getCurrentUser().then(user => {
      //     this.user = user
      // })
      const urlParams = this.getRequestParams();

      this.authValue = urlParams.auth;
      const tokenValue = urlParams.token;
      const [robotId, userId, token] = Buffer.from(decodeURIComponent(tokenValue), 'base64').toString().split("_");
    },
    clearSearch() {
      // 通知父组件清除搜索
      this.$parent.$emit('search-change', '')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/fonts/iconfont.css';

.mycard {
  position: relative;
  width: 100%;
  height: 100%;

  .avatar {
    width: 36px;
    height: 36px;
    margin: 20px 12px 0 12px;
    border-radius: 2px;
  }

  .navbar {
    width: 100%;
    text-align: center;

    .icon {
      display: inline-block;
      font-size: 26px;
      margin-top: 28px;
      padding: 0 16px;
      box-sizing: border-box;
      color: rgb(173, 174, 175);
      opacity: 0.8;
      cursor: pointer;

      &.active {
        color: rgb(0, 220, 65);
      }

      &:hover {
        opacity: 1;
      }
    }

    .icon-msg,
    .icon-more {
      font-size: 22px;
    }

    .icon-msg {
      padding: 0 19px;
    }
  }

  footer {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// mycard.vue?2e242f5c